<template>
  <div class="noAuth">
    <h1>No Auth</h1>
  </div>
</template>
